import { Views } from '../enum';
import { setElementVisibility, setElementsVisibility } from '../util/visibility';

export const updateActiveView = (activeView: Views) => {
    setElementsVisibility(Object.values(Views), false);
    setElementVisibility(activeView, true);
};
